<template>
    <div>
        <div v-if="delta > 0" class="txt-webinar-begins">{{headline}}</div>
        <div class="txt-webinar-countdown">
            <!-- 20 Days, 23 Hours and 58 Minutes -->
            {{prettyCountdown}}
        </div>
    </div>
</template>

<script>
'use strict'
/* eslint-disable */

import utils from "@/utils/utils"

var data = {
  loaded: false,
  debug: false,
  refDate: null,
  endDate: null,
  delta: 0,
  timer: null,
  alarmSent: false,   // set True when the Enter Webinar button is activated
  countdownStarted: false  // set True after first test of countdown in interval func
 }

export default {
  name: "Countdown",
  data() {
    return data
  },
  props: {
    serverTime: {
      type: String,
      required: true,
      default: ""
    },
    endTime: {
      type: String,
      required: true,
      default: ""
    },
    headline: {
        type: String,
        required: false,
        default: "Live Webinar Begins In:"
    },
    alarmSeconds: {
      type: Number,
      required: false,
      default: 3600  // 1800 = 30 minutes
    }
  },
  computed: {
      prettyCountdown() {
          return (this.loaded) ? utils.prettyCountdown(this.delta) : ''
      }
  },
  methods: {
    setDelta() {
      this.delta = Math.floor( (this.endDate.getTime() - this.refDate.getTime())/1000 )
      if (this.debug) console.log(`new delta: ${this.delta}`)
    }
  },
  watch: {
    // serverTime: function(newVal, oldVal) {
    //   console.log(`serverTime changed: ${newVal}  old: ${oldVal}`)
    //   this.refDate = new Date(this.serverTime)
    // },
    endTime: function(newVal, oldVal) {
      if (this.debug) console.log(`endTime changed: ${newVal}  old: ${oldVal}  endTime: ${this.endTime}`)
      this.endDate = new Date(this.endTime)
      this.setDelta()
    }
  },
  created() {
    this.alarmSent = false
  },
  mounted() {
    if (this.debug) console.log(`Countdown  ${this.serverTime}  ${this.endTime}  alarmSeconds: ${this.alarmSeconds}`)
    this.refDate = new Date(this.serverTime)
    this.endDate = new Date(this.endTime)
    // console.log(`Countdown Dates  ${this.serverTime.toString()}  ${this.endTime.toString()}`)
    // convert to seconds from milliseconds
    this.setDelta()
    // refresh every second
    this.timer = setInterval( ( function() {
            --this.delta   // subtract 1 second
            // adjust delta downward to nearest minute for comparison
            if (!this.alarmSent && (this.alarmSeconds > 0) && ((this.delta-(this.delta % 60)) <= this.alarmSeconds)) {
                this.alarmSent = true
                if (this.debug) console.log(`Event: countdown-alarm: ${this.alarmSeconds} ${this.delta}`)
                this.$emit('countdown-alarm')
            }
            if (this.delta <= 0) {
                // console.log(`countdown timer stopped`)
                clearInterval(this.timer)
                this.timer = null
            }
            if (!this.countdownStarted) this.$emit('countdown-started')
            this.countdownStarted = true
        }).bind(this), 1000)  // decrease seconds
    this.loaded = true
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.alarmSent = false
    this.countdownStarted = false
    this.loaded = false
    this.timer = null
  }
}
</script>

<style scoped>
    .txt-webinar-begins {
    color: black;
    font-weight: bold;
    font-size: 1.2rem;
    }
    .txt-webinar-countdown {
    color: red;
    font-weight: bold;
    font-size: 1.2rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/Countdown.vue